/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".title-name[_ngcontent-%COMP%]{background:#f0f8ff;text-align:center}  .activity-details-table-wrapper .ui-table-scrollable-body-table{width:auto}"];
export { styles as styles };
